import React from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../common/GridLayout";

import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  ColumnChooserSearch,
  HeaderFilter,
  ColumnFixing,
  Scrolling,
  StateStoring,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";
let detailInDataGrid = React.createRef();
let accessToken = '';
const gridKey = "aad1310d-a823-4199-b6ea-ed7e778499b6";
const statusLookup = [
    { ID: 'O', Text: "Open" },
    { ID: 'H', Text: "Hold" },
    { ID: 'L', Text: "Ready To Commit Later" },
    { ID: 'N', Text: "Ready To Commit Now" },
];
const toStage = [
    { ID: 'L', Text: 'Canceled - No Inventory Effect' },
    { ID: 'Q', Text: 'Quote - No Inventory Effect' },
    { ID: 'P', Text: 'Plan - No Inventory Effect' },
    { ID: 'F', Text: 'Future - No Effect on Net Available' },
    { ID: 'N', Text: 'Pending - Effects Net Available' },
    { ID: 'A', Text: 'Assigned - Effects Available' },
    { ID: 'S', Text: 'Picked/Staged - Effects Available' },
    { ID: 'C', Text: 'Shipped/Completed - Effects Available' }
];
class WMTransactionsGridPreview extends React.Component {

    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;

        this.state = {
            records: 0
        }
        this.loadState = this.loadState.bind(this);
        this.saveState = this.saveState.bind(this);
    }

    loadState() {
        // const { gridKey, accessToken } = this.state;
        return GridLayout.sendStorageRequest(gridKey, "GET", accessToken);
    }

    saveState(state) {
        GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state);
    }
    render() {
        return (
            <div className="row wm-transactions-grid-preview">
                <style>{`
                    .wm-transactions-grid-preview .dx-datagrid-total-footer > .dx-datagrid-content {
                        padding-top: 2px;
                        padding-bottom: 2px;
                    }
                    .wm-transactions-grid-preview .dx-datagrid-total-footer .dx-row > td {
                        padding-top: 2px;
                        padding-bottom: 2px;
                        line-height: 1.2;
                    }
                `}</style>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={this.props.dataSource}
                    showBorders={true}
                    ref={detailInDataGrid}
                    className="customDataTableDesignCommit"
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    columnAutoWidth={true}
                    showRowLines={true}
                    width="80vw"
                    height="60vh"
                >
                    <Scrolling mode="virtual" useNative={false} />
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <ColumnFixing enabled={true} />
                    <ColumnHeaderFilter />
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting visible={true} mode="multiple" />
                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={10} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                        showNavigationButtons={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <HeaderFilter />
                    <GroupPanel visible={true} />
                    <Grouping autoExpandAll={false} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={this.loadState}
                        storageKey={gridKey}
                        customSave={this.saveState}
                    />
                    <Column
                        dataField="identityId"
                        caption="Customer"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="transactionNumber"
                        caption="Transaction #"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="transactionDate"
                        caption="Transaction Date"
                        allowEditing={false}
                        dataType="datetime" format="MM/dd/yyyy hh:mm:ss"
                    ></Column>
                    <Column
                        dataField="reference"
                        caption="Reference"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="actualReceivedShippedDateTime"
                        caption="Recv/Ship Date"
                        allowEditing={false}
                        dataType="datetime" format="MM/dd/yyyy"
                    ></Column>
                    <Column
                        dataField="shipperBolNumber"
                        caption="Shipper #"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="fiscalYear"
                        caption="Fiscal Year"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="fiscalPeriod"
                        caption="Fiscal Period"
                        allowEditing={false}
                    ></Column>
                    <Column
                        dataField="userDefinedCode1"
                        caption="Code1"
                        visible={false}
                    ></Column>
                    <Column
                        dataField="userDefinedCode2"
                        caption="Code2"
                        visible={false}
                    ></Column>
                    <Column
                        dataField="userDefinedCode3"
                        caption="Code3"
                        visible={false}
                    ></Column>
                    <Column
                        dataField="userDefinedCode4"
                        caption="Code4"
                        visible={false}
                    ></Column>
                    <Column
                        dataField="userDefinedCode5"
                        caption="Code5"
                        visible={false}
                    ></Column>
                    <Column
                        dataField="department"
                        caption="Department"
                        visible={false}
                    ></Column>
                    <Column
                        dataField="name"
                        caption="Name"
                        visible={false}
                    ></Column>
                     <Column
                        dataField="profileCode"
                        caption="Profile"
                        visible={false}
                    ></Column>
                     <Column
                        dataField="recordNumber"
                        caption="Record#"
                        visible={false}
                    ></Column>
                    <Summary>
                        <TotalItem
                            column="identityId"
                            summaryType="count"
                            displayFormat="Total Records: {0}"
                        />
                    </Summary>
                </DataGrid>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(WMTransactionsGridPreview);